module.exports = __webpack_public_path__ + "img/white_knight.321097b9.png";